// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models/SessionModels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { StringValue } from "../../../google/protobuf/wrappers";
import { Host } from "./HostModels";
import { Orchestrator } from "./OrcModels";

export const protobufPackage = "daisi.protos.v1";

export interface CreateSessionRequest {
  ModelName: string;
  DirectConnectRequired: boolean;
  PreferredHostNames: string[];
  PreferredRegion?: string | undefined;
  NetworkName?: string | undefined;
  HostId?: string | undefined;
}

export interface CreateSessionResponse {
  Id: string;
  Success: boolean;
  Host?: Host | undefined;
  MoveToOrc?: Orchestrator | undefined;
}

export interface ClaimSessionRequest {
  Id: string;
}

export interface ClaimSessionResponse {
  Success: boolean;
  ModelName?: string | undefined;
}

export interface CloseSessionRequest {
  Id: string;
}

export interface CloseSessionResponse {
  Success: boolean;
}

export interface ConnectRequest {
  SessionId: string;
}

export interface ConnectResponse {
  Id: string;
  HasCapacity: boolean;
  AlreadyConnected: boolean;
}

function createBaseCreateSessionRequest(): CreateSessionRequest {
  return {
    ModelName: "",
    DirectConnectRequired: false,
    PreferredHostNames: [],
    PreferredRegion: undefined,
    NetworkName: undefined,
    HostId: undefined,
  };
}

export const CreateSessionRequest: MessageFns<CreateSessionRequest> = {
  encode(message: CreateSessionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ModelName !== "") {
      writer.uint32(10).string(message.ModelName);
    }
    if (message.DirectConnectRequired !== false) {
      writer.uint32(16).bool(message.DirectConnectRequired);
    }
    for (const v of message.PreferredHostNames) {
      StringValue.encode({ value: v!! }, writer.uint32(26).fork()).join();
    }
    if (message.PreferredRegion !== undefined) {
      StringValue.encode({ value: message.PreferredRegion! }, writer.uint32(34).fork()).join();
    }
    if (message.NetworkName !== undefined) {
      StringValue.encode({ value: message.NetworkName! }, writer.uint32(42).fork()).join();
    }
    if (message.HostId !== undefined) {
      StringValue.encode({ value: message.HostId! }, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateSessionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ModelName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.DirectConnectRequired = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.PreferredHostNames.push(StringValue.decode(reader, reader.uint32()).value);
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.PreferredRegion = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.NetworkName = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.HostId = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateSessionRequest {
    return {
      ModelName: isSet(object.ModelName) ? globalThis.String(object.ModelName) : "",
      DirectConnectRequired: isSet(object.DirectConnectRequired)
        ? globalThis.Boolean(object.DirectConnectRequired)
        : false,
      PreferredHostNames: globalThis.Array.isArray(object?.PreferredHostNames)
        ? object.PreferredHostNames.map((e: any) => String(e))
        : [],
      PreferredRegion: isSet(object.PreferredRegion) ? String(object.PreferredRegion) : undefined,
      NetworkName: isSet(object.NetworkName) ? String(object.NetworkName) : undefined,
      HostId: isSet(object.HostId) ? String(object.HostId) : undefined,
    };
  },

  toJSON(message: CreateSessionRequest): unknown {
    const obj: any = {};
    if (message.ModelName !== "") {
      obj.ModelName = message.ModelName;
    }
    if (message.DirectConnectRequired !== false) {
      obj.DirectConnectRequired = message.DirectConnectRequired;
    }
    if (message.PreferredHostNames?.length) {
      obj.PreferredHostNames = message.PreferredHostNames;
    }
    if (message.PreferredRegion !== undefined) {
      obj.PreferredRegion = message.PreferredRegion;
    }
    if (message.NetworkName !== undefined) {
      obj.NetworkName = message.NetworkName;
    }
    if (message.HostId !== undefined) {
      obj.HostId = message.HostId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateSessionRequest>, I>>(base?: I): CreateSessionRequest {
    return CreateSessionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateSessionRequest>, I>>(object: I): CreateSessionRequest {
    const message = createBaseCreateSessionRequest();
    message.ModelName = object.ModelName ?? "";
    message.DirectConnectRequired = object.DirectConnectRequired ?? false;
    message.PreferredHostNames = object.PreferredHostNames?.map((e) => e) || [];
    message.PreferredRegion = object.PreferredRegion ?? undefined;
    message.NetworkName = object.NetworkName ?? undefined;
    message.HostId = object.HostId ?? undefined;
    return message;
  },
};

function createBaseCreateSessionResponse(): CreateSessionResponse {
  return { Id: "", Success: false, Host: undefined, MoveToOrc: undefined };
}

export const CreateSessionResponse: MessageFns<CreateSessionResponse> = {
  encode(message: CreateSessionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.Success !== false) {
      writer.uint32(16).bool(message.Success);
    }
    if (message.Host !== undefined) {
      Host.encode(message.Host, writer.uint32(26).fork()).join();
    }
    if (message.MoveToOrc !== undefined) {
      Orchestrator.encode(message.MoveToOrc, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateSessionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateSessionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Host = Host.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.MoveToOrc = Orchestrator.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateSessionResponse {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Host: isSet(object.Host) ? Host.fromJSON(object.Host) : undefined,
      MoveToOrc: isSet(object.MoveToOrc) ? Orchestrator.fromJSON(object.MoveToOrc) : undefined,
    };
  },

  toJSON(message: CreateSessionResponse): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Host !== undefined) {
      obj.Host = Host.toJSON(message.Host);
    }
    if (message.MoveToOrc !== undefined) {
      obj.MoveToOrc = Orchestrator.toJSON(message.MoveToOrc);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateSessionResponse>, I>>(base?: I): CreateSessionResponse {
    return CreateSessionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateSessionResponse>, I>>(object: I): CreateSessionResponse {
    const message = createBaseCreateSessionResponse();
    message.Id = object.Id ?? "";
    message.Success = object.Success ?? false;
    message.Host = (object.Host !== undefined && object.Host !== null) ? Host.fromPartial(object.Host) : undefined;
    message.MoveToOrc = (object.MoveToOrc !== undefined && object.MoveToOrc !== null)
      ? Orchestrator.fromPartial(object.MoveToOrc)
      : undefined;
    return message;
  },
};

function createBaseClaimSessionRequest(): ClaimSessionRequest {
  return { Id: "" };
}

export const ClaimSessionRequest: MessageFns<ClaimSessionRequest> = {
  encode(message: ClaimSessionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClaimSessionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClaimSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClaimSessionRequest {
    return { Id: isSet(object.Id) ? globalThis.String(object.Id) : "" };
  },

  toJSON(message: ClaimSessionRequest): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClaimSessionRequest>, I>>(base?: I): ClaimSessionRequest {
    return ClaimSessionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClaimSessionRequest>, I>>(object: I): ClaimSessionRequest {
    const message = createBaseClaimSessionRequest();
    message.Id = object.Id ?? "";
    return message;
  },
};

function createBaseClaimSessionResponse(): ClaimSessionResponse {
  return { Success: false, ModelName: undefined };
}

export const ClaimSessionResponse: MessageFns<ClaimSessionResponse> = {
  encode(message: ClaimSessionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.ModelName !== undefined) {
      StringValue.encode({ value: message.ModelName! }, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClaimSessionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClaimSessionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ModelName = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClaimSessionResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      ModelName: isSet(object.ModelName) ? String(object.ModelName) : undefined,
    };
  },

  toJSON(message: ClaimSessionResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.ModelName !== undefined) {
      obj.ModelName = message.ModelName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClaimSessionResponse>, I>>(base?: I): ClaimSessionResponse {
    return ClaimSessionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClaimSessionResponse>, I>>(object: I): ClaimSessionResponse {
    const message = createBaseClaimSessionResponse();
    message.Success = object.Success ?? false;
    message.ModelName = object.ModelName ?? undefined;
    return message;
  },
};

function createBaseCloseSessionRequest(): CloseSessionRequest {
  return { Id: "" };
}

export const CloseSessionRequest: MessageFns<CloseSessionRequest> = {
  encode(message: CloseSessionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CloseSessionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCloseSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CloseSessionRequest {
    return { Id: isSet(object.Id) ? globalThis.String(object.Id) : "" };
  },

  toJSON(message: CloseSessionRequest): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CloseSessionRequest>, I>>(base?: I): CloseSessionRequest {
    return CloseSessionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CloseSessionRequest>, I>>(object: I): CloseSessionRequest {
    const message = createBaseCloseSessionRequest();
    message.Id = object.Id ?? "";
    return message;
  },
};

function createBaseCloseSessionResponse(): CloseSessionResponse {
  return { Success: false };
}

export const CloseSessionResponse: MessageFns<CloseSessionResponse> = {
  encode(message: CloseSessionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CloseSessionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCloseSessionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CloseSessionResponse {
    return { Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false };
  },

  toJSON(message: CloseSessionResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CloseSessionResponse>, I>>(base?: I): CloseSessionResponse {
    return CloseSessionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CloseSessionResponse>, I>>(object: I): CloseSessionResponse {
    const message = createBaseCloseSessionResponse();
    message.Success = object.Success ?? false;
    return message;
  },
};

function createBaseConnectRequest(): ConnectRequest {
  return { SessionId: "" };
}

export const ConnectRequest: MessageFns<ConnectRequest> = {
  encode(message: ConnectRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SessionId !== "") {
      writer.uint32(10).string(message.SessionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConnectRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConnectRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SessionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConnectRequest {
    return { SessionId: isSet(object.SessionId) ? globalThis.String(object.SessionId) : "" };
  },

  toJSON(message: ConnectRequest): unknown {
    const obj: any = {};
    if (message.SessionId !== "") {
      obj.SessionId = message.SessionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConnectRequest>, I>>(base?: I): ConnectRequest {
    return ConnectRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConnectRequest>, I>>(object: I): ConnectRequest {
    const message = createBaseConnectRequest();
    message.SessionId = object.SessionId ?? "";
    return message;
  },
};

function createBaseConnectResponse(): ConnectResponse {
  return { Id: "", HasCapacity: false, AlreadyConnected: false };
}

export const ConnectResponse: MessageFns<ConnectResponse> = {
  encode(message: ConnectResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.HasCapacity !== false) {
      writer.uint32(16).bool(message.HasCapacity);
    }
    if (message.AlreadyConnected !== false) {
      writer.uint32(24).bool(message.AlreadyConnected);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConnectResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConnectResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.HasCapacity = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.AlreadyConnected = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConnectResponse {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      HasCapacity: isSet(object.HasCapacity) ? globalThis.Boolean(object.HasCapacity) : false,
      AlreadyConnected: isSet(object.AlreadyConnected) ? globalThis.Boolean(object.AlreadyConnected) : false,
    };
  },

  toJSON(message: ConnectResponse): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.HasCapacity !== false) {
      obj.HasCapacity = message.HasCapacity;
    }
    if (message.AlreadyConnected !== false) {
      obj.AlreadyConnected = message.AlreadyConnected;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConnectResponse>, I>>(base?: I): ConnectResponse {
    return ConnectResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConnectResponse>, I>>(object: I): ConnectResponse {
    const message = createBaseConnectResponse();
    message.Id = object.Id ?? "";
    message.HasCapacity = object.HasCapacity ?? false;
    message.AlreadyConnected = object.AlreadyConnected ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
